import { render } from "./ExcelIcon.vue?vue&type=template&id=39d02c3c"
const script = {}
script.render = render

export default script